import { Empty, Spin } from 'antd';

export default function LoadingMenu() {
    return (
        <Empty
            image={<Spin size="default" />}
            description=""
            imageStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        />
    );
}
